import { useGetNavigationMenu } from "../../Shared/Navigation/navigationMenu/useGetNavigationMenu";
import {
  NavigationItem as NavigationItemParams,
  NavigationSection as NavigationSectionParams,
} from "../../Shared/Navigation/navigationMenu/types";
import { useAdminMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/AdminMenuPriviligesProvider";
import { useWorkerMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/WorkerMenuPriviligesProvider";
import { useWorkplaceMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/WorkplaceMenuPriviligesProvider";
import { useUnreadChannelCount } from "../../Shared/Navigation/useUnreadChannelCount";
import { NavigationMenuItemMobile } from "@src/appV2/redesign/AppLayout/Mobile/Navigation/MenuItem";
import { NavigationMenuSectionTitleMobile } from "@src/appV2/redesign/AppLayout/Mobile/Navigation/MenuSectionTitle";

export interface NavigationMenuItemsMobileProps {
  isAdmin: boolean;
  isWorkplace: boolean;
  isWorker: boolean;
  closeSidenav: () => void;
}

export function NavigationMenuItemsMobile(props: NavigationMenuItemsMobileProps) {
  const { isAdmin, isWorker, isWorkplace, closeSidenav } = props;

  const currentPath = location.pathname;
  const adminMenuPriviliges = useAdminMenuPriviligesProviderContext();
  const workplaceMenuPriviliges = useWorkplaceMenuPriviligesProviderContext();
  const workerMenuPriviliges = useWorkerMenuPriviligesProviderContext();
  const unreadChannelCount = useUnreadChannelCount();

  const navigationMenu = useGetNavigationMenu(
    isAdmin,
    adminMenuPriviliges,
    isWorker,
    workerMenuPriviliges,
    isWorkplace,
    workplaceMenuPriviliges,
    currentPath,
    { unreadChannelCount }
  );

  function NavigationItem(params: NavigationItemParams) {
    const { label, iconType, isSelected, routeTo, onClick, badgeCount } = params;

    return (
      <NavigationMenuItemMobile
        iconType={iconType}
        isSelected={isSelected}
        routeTo={routeTo}
        onClick={() => {
          if (onClick) {
            onClick();
          }
          closeSidenav();
        }}
        badgeCount={badgeCount}
      >
        {label}
      </NavigationMenuItemMobile>
    );
  }

  function NavigationSection(params: NavigationSectionParams) {
    const { label, items } = params;

    return (
      <>
        <NavigationMenuSectionTitleMobile>{label}</NavigationMenuSectionTitleMobile>
        {items.map((item) => (
          <NavigationItem key={item.label} {...item} />
        ))}
      </>
    );
  }

  return (
    <>
      {navigationMenu.items.map((item) =>
        "items" in item ? (
          <NavigationSection key={item.label} {...item} />
        ) : (
          <NavigationItem key={item.label} {...item} />
        )
      )}
    </>
  );
}
